import { createSlice,createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getVendorInvoiceSummary } from "../../modules/fiscalUpgrade/services/Invoices/Vendor/VenodrInvoiceSummaryService";

export interface SingleInvoice {
  id: number;
  amount: number;
  vendorName: string;
}

export interface VendorInvoiceState {
  loading: boolean;
  invoices: SingleInvoice[];
  totalRecordCount: number;
  assignedTo: string;
  invoiceId: string;
  error: string | null;
  selectedFiles:any [];
  selectedEmail:string;
  taskSummaryList: any[];
  approversList: any[]; 
  taskId :number;
  invoiceHistoryList:any[];
  summaryNav:string;
}

const initialState: VendorInvoiceState = {
  loading: false,
  invoices: [],
  totalRecordCount: 0,
  assignedTo: "",
  invoiceId: "",
  error: null, 
  selectedFiles:[] as File[],
  selectedEmail:"",
  taskSummaryList: [],
  approversList : [],
  taskId : 0,
  invoiceHistoryList: [],
  summaryNav:""
};


export const fetchVendorInvoices = createAsyncThunk('vendorInvoice/fetchVendorInvoices',
  async ({ page, rowsPerPage }: { page: number; rowsPerPage: number }, thunkAPI) => {
    const filter = {
      "page": 1,
      "size": 5
    }
    try {

      const response = await getVendorInvoiceSummary({ filter });
      return response.data; // { message, data, totalRecordCount }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
const vendorInvoiceSlice = createSlice({
    name: 'vendorInvoice',
    initialState,
    reducers: {
      setCreateVendorInvoice: (state, action: PayloadAction<Partial<VendorInvoiceState>>) => {
        return { ...state, ...action.payload };
      }

    }, 
    extraReducers: (builder) => {
      builder
        .addCase(fetchVendorInvoices.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchVendorInvoices.fulfilled, (state, action) => {
          state.loading = false;
          state.invoices = action.payload.data;
          state.totalRecordCount = action.payload.totalRecordCount;
        })
        .addCase(fetchVendorInvoices.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
        });
    },
  });
  export const { setCreateVendorInvoice } = vendorInvoiceSlice.actions;
  export default vendorInvoiceSlice.reducer;
  
